import React, { useEffect, useRef, useState } from 'react'
import CommonCard from '../../../Components/common/CommonCard'
import { CallApi } from '../../../Components/common/CommonFunctions';
import { toast } from 'react-toastify';
import Select from 'react-select';
import ApexCharts from 'react-apexcharts';

import records from '../../../assets/images/recovery_dahboard/records.svg';
import info from '../../../assets/images/recovery_dahboard/info.svg';
import critical from '../../../assets/images/recovery_dahboard/star.svg';
import { ReactComponent as Time } from "../../../assets/images/recovery_dahboard/time.svg";
import { ReactComponent as Flag } from "../../../assets/images/icon_svg/flag.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import ProgressBar from 'react-bootstrap/ProgressBar';

const Dashboard = ({ dropData, onNav }) => {

    const isMounted = useRef(false);
    const [regionsList, setRegionsList] = useState([]);
    const [userList, setUserList] = useState([])
    const [filterData, setFilterData] = useState({assign_to: 'all', region_id: 'all'});
    const [pageData, setPageData] = useState({});

    const [openCaseOptions, setOpenCaseOptions] = useState({
        chart: {
            type: 'area',
            height: 350,
            toolbar: {
                show: false, // This will hide the toolbar
                
            },
            zoom: {
                    enabled: false
                },

        },
        
        plotOptions: {
            
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        markers: {
            size: 4,
            strokeWidth: 2,
            strokeColors: "#1D4ED8"
        },
        dataLabels: {
            enabled: true,
            offsetY: -10,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            },
            background: {
                enabled: false
            }
        },
        stroke: {
            show: true,
            curve: 'smooth',
            width: 2,
            colors: ['#1D4ED8']
        },
        xaxis: {
            categories: []
            // [
            //     '30 MAR',
            //     '31 MAR',
            //     '01 APR',
            //     '02 APR',
            //     '03 APR',
            //     '04 APR',
            //     '05 APR',
            //     '06 APR',
            //     '07 APR',
            //     '08 APR',
            // ]
            ,
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            title: {
                text: ' '
            },
            min: 0,
            // max: 500,
            tickAmount: 5,
            labels: {
                formatter: (val) => Math.round(val),
            },
        },
        fill: {
            opacity: 1,
            colors: [
                "rgba(29, 78, 216, 0.80)",
                // "rgba(203, 140, 255, 1)",
                // "rgba(99, 169, 255, 1)",
                // 'rgba(84, 202, 82, 1)',
                // 'rgba(255, 107, 107, 1)',
            ]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " Records";
                }
            }
        }
    });

    const [openCaseSeries, setOpenCaseSeries] = useState([
        {
            name: '',
            data: []  // [421, 383, 372, 392, 458, 422, 348, 100, 420, 350,]
        },
    ]);

    const fetchRegion = async () => {
        CallApi({
            endPoint: `setting/region-dropdown`,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                const regionOpt = [
                    { label: 'All Regions', value: 'all' },
                    ...(innerData || [])
                ];
                setRegionsList(regionOpt);
                // fetchAllData({ region_id: innerData[0].value })
                // setFilterData(prev => ({...prev, region_id: 'all' }))
            },
            onError: (msg) => toast.error(msg)
        });
    };
    const fetchUser = async () => {
        CallApi({
            endPoint: 'v2/service-recovery/assign-user-list',
            // payload: { service_recovery_id: detID.service_recovery_id },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    const assignUserOpt = [
                        // { label: 'Deselect User', value: '' },
                        { label: 'All Users', value: 'all' },
                        ...(innerData || [])
                    ];
                    setUserList(assignUserOpt);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const fetchAllData = async (data) => {  
        const payLoad = {
            assign_to: data?.assign_to === 'all' ? '' : data?.assign_to,
            region_id: data?.region_id === 'all' ? '' : data?.region_id
        }      
        CallApi({
            endPoint: `v2/service-recovery/dashboard`,
            payload: payLoad,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                setPageData(innerData);

                const condLabel = innerData?.last_10_days_open_case ? innerData?.last_10_days_open_case?.map((item) => item.name) : [];
                const condData = innerData?.last_10_days_open_case ? innerData?.last_10_days_open_case?.map((item) => item.count) : [];
                setOpenCaseOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                // const condcolors = [
                //     'rgba(54, 162, 235, 1)',
                // ];

                const condsData = condData.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    // fillColor: condcolors[index % condcolors.length]
                }));
                setOpenCaseSeries([{
                    // name: "ULD's",
                    data: condsData
                }]);
            },
            onError: (msg) => toast.error(msg)
        });
    };
    useEffect(() => {
        if (isMounted.current) return;
        fetchRegion();
        fetchUser();
        fetchAllData();
        isMounted.current = true;
    }, []);

    const filterChange = (name, data) => {
        
        let sendData = {}
        let sdata = data.value === 'all' ? '' : data.value
        if (name == 'assign_to') {
            sendData = { ...filterData, [name]: sdata, assign_to_type: data.type, }
            setFilterData(prev => ({
                ...prev,
                [name]: data.value,
                assign_to_type: data.type,
            }));
        } else {
            sendData = { ...filterData, [name]: sdata }
            setFilterData(prev => ({
                ...prev,
                [name]: data.value
            }));
        }
        fetchAllData(sendData)
    }

    const cards = [
        { icon: 'records', title: 'Open Records', value: pageData?.open_records },
        { icon: 'info', title: 'Action Required', value: pageData?.action_records },
        { icon: 'critical', title: 'Critical Records', value: pageData?.critical_records },
    ];
    const iconMap = { records, info, critical, };

    const goOverview = (pos, label, value) => {
        if (label === 'OR') {
            onNav({ path: pos }, '', '')
        } else if (label === 'AR') {
            const sFilter = { action: [22] };
            localStorage.setItem('PreFilter', JSON.stringify(sFilter));
            onNav({ path: pos }, '', '', 'filter')
        } else {
            const findVal = dropData?.priority_type?.find(pt => pt.label === value)
            const sFilter = { [label]: [findVal.value] };
            localStorage.setItem('PreFilter', JSON.stringify(sFilter));
            onNav({ path: pos }, '', '', 'filter')
        }

    }

    return (
        <div className='main-content '>
            <div className='d-flex gap-3 mb-3'>
                <div className='d-flex gap-3 tw-75'>
                    <div className='tw-25'>
                        <div className='global_roundbg mb-3'>
                            <div className='gl_top'>
                                <span className='border_icon'><Time /></span>
                                <button className="filter_side_btn" onClick={() => goOverview('OV', 'OR')}>View Cases<span>
                                    <FontAwesomeIcon icon={faAngleRight} /></span>
                                </button>
                            </div>
                            <h3>Open Records</h3>
                            <p className='gl_value'>{pageData?.open_records}</p>
                        </div>
                        <div className='global_roundbg'>
                            <div className='gl_top'>
                                <span className='border_icon'><Time /></span>
                                {/* <button className="filter_side_btn " onClick={() => goOverview('OV', 'AR')}>View Cases<span>
                                    <FontAwesomeIcon icon={faAngleRight} /></span>
                                </button> */}
                            </div>
                            <h3>Action Required</h3>
                            <p className='gl_value'>{pageData?.action_records}</p>
                        </div>
                    </div>
                    <div className='tw-75'>
                        <div className='global_roundbg h-100'>
                            <div className='box_icon_text'>
                                <span className='border_icon'><Time /></span>
                                <h3>Open Cases by Priority</h3>
                            </div>
                            <div className="card-bx mb-0">
                                {pageData?.priority_status?.map((status, index) => {
                                    const color = { Low: 'gray_card', Medium: 'orange_card', High: 'red_card', Critical: 'dip_red' }
                                    return (
                                        <div className={`min-hgt-19 justify-content-center gap-2 card ${color[status.name] || ''}`} key={status.name + '_' + index}>
                                            <div className="card-top justify-content-around">
                                                <span className='color_box'>{status.name}</span>
                                            </div>

                                            <h2 className='text-center'>{status.total_count}</h2>
                                            <p className="text-center">{status.action_required_count} Action Required</p>
                                            <button className="filter_bottom_btn" onClick={() => goOverview('OV', 'priority', status.name)}>View Cases<span>
                                                <FontAwesomeIcon icon={faAngleRight} /></span>
                                            </button>
                                        </div>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </div>
                {/* {console.log('filterData',filterData)}
                {console.log('userList',userList)} */}
                <div className='tw-24'>
                    <div className="global_roundbg h-100">
                        <div className='box_icon_text'>
                            <span className='border_icon'><Time /></span>
                            <h3>Filters</h3>
                        </div>
                        <div className="gl_title">Region</div>
                        <Select
                            options={regionsList}
                            onChange={selected => filterChange('region_id', selected)}
                            placeholder="Select Region"
                            className="region_selct"
                            name="region_id"
                            value={regionsList?.find(option => option.value === filterData?.region_id) || null}
                        />
                        <div className="gl_title mt-3">Case Owner</div>
                        <Select
                            options={userList}
                            onChange={selected => filterChange('assign_to', selected)}
                            placeholder="All Owners"
                            className="region_selct"
                            name="region_id"
                            value={userList?.find(opt => opt.value === filterData?.assign_to) || null}
                        />
                    </div>
                </div>
            </div>

            <div className='d-flex gap-3'>
                <div className='tw-78'>

                    <div className='global_roundbg'>
                        <div className='box_icon_text'>
                            <span className='border_icon'><Time /></span>
                            <h3>Open Cases Trend (Last 10 Days)</h3>
                        </div>
                        <ApexCharts
                            options={openCaseOptions}
                            series={openCaseSeries}
                            type="area"
                            height={480}
                        />
                    </div>

                </div>
                <div className='tw-25'>
                    <div className='global_roundbg mb-3 min-hgt-10'>
                        <div className='box_icon_text'>
                            <span className='border_icon'><Flag /></span>
                            <h3>Top 5 Reporting Stations</h3>
                        </div>
                        {pageData?.top_5_reporting_station?.length ? pageData?.top_5_reporting_station?.map((stn, index) => (
                            <div className='bar_list'>
                                <div className='d-flex justify-content-between align-items-center mb-1 bar_box'>
                                    <h3>{stn.station}</h3>
                                    <div className='ship_text'><span className='count_ship'>{stn.total} Shipments</span> <span className='percetage'>{stn.percentage}%</span></div>
                                </div>
                                <ProgressBar now={stn.percentage} />
                            </div>
                        ))
                            : <></>
                        }

                    </div>
                    <div className='global_roundbg min-hgt-10'>
                        <div className='box_icon_text'>
                            <span className='border_icon'><Time /></span>
                            <h3>Top 5 Recovery Aspects</h3>
                        </div>
                        {pageData?.top_5_recovery_aspects?.length ? pageData?.top_5_recovery_aspects?.map((stn, index) => (
                            <div className='bar_list'>
                                <div className='d-flex justify-content-between align-items-center mb-1 bar_box'>
                                    <h3>{stn.name}</h3>
                                    <div className='ship_text'><span className='count_ship'>{stn.total} Shipments</span> <span className='percetage'>{stn.percentage}%</span></div>
                                </div>
                                <ProgressBar now={stn.percentage} />
                            </div>
                        ))
                            : <></>
                        }
                    </div>



                </div>
            </div>

        </div>
    )
}

export default Dashboard